import { fromJS } from 'immutable'
import {
  LEAVE_TYPE_DELETE_REQUEST,
  LEAVE_TYPE_DELETE_SUCCESS,
  LEAVE_TYPE_DELETE_FAILURE,
  LEAVE_TYPE_DELETE_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case LEAVE_TYPE_DELETE_REQUEST:
      return state
        .set('isFetching', true)
    case LEAVE_TYPE_DELETE_SUCCESS:
      return state
        .set('deletedLeaveType', fromJS(action.payload.deletedLeaveType))
        .set('status', 200)
        .set('message', 'Deleted Successfully.')
        .set('isFetching', false)
    case LEAVE_TYPE_DELETE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('deletedLeaveType', fromJS(action.payload.message))
        .set('status', 'Error')
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case LEAVE_TYPE_DELETE_RESET:
      return state
        .delete('deletedLeaveType')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/leave-type/leave-type-delete-reducer.js